<div class="row ps-3">
  <label class="col-4">{{ 'TPL_FILTER_HANDELSSORTIMENT' | translate }}</label>
  <label class="col-8  ps-4">{{ 'TPL_FILTER_TRANSPORTFORETAG' | translate }}</label>
</div>

@for (row of rows; track row; let i = $index) {
  @if (row.visible) {
    <div class="row ps-3">
      <div class="col-4 mt-2">
        {{ row.handelssortimentNamn }}
      </div>
      <div class="col-8 pb-3">
        <rask-selector
          [formatter]="optionFormatter"
          [viewFormatter]="optionViewFormatter"
          [values]="options.values"
          class="w-100 low"
          [(ngModel)]="row.selected"
          (change)="transportforetagChange($event)">
        </rask-selector>
      </div>
    </div>
  }
}

@if (warningFdBefraktare) {
  <div class="row ps-3">
    <rask-validation-message-row type="warning" [message]="warningFdBefraktare">
    </rask-validation-message-row>
  </div>
}